// ============================================================
// Unified API Client
// ============================================================
// Re-exports the configured Axios instance from axios.js so all
// super-admin, auth, and feature modules share the same interceptors
// and error formatting.

import apiClient from './axios';

export default apiClient;
